import {
  Action,
  ActionType,
  IVerifyOTPResponse,
} from "models/setting/verifyOTP";
import createReducer from "redux/createReducer";

export interface VerifyOTPReducerType {
  loading: boolean;
  error?: string;
  verifyOTPResponse?: IVerifyOTPResponse;
}

const defaultState: VerifyOTPReducerType = {
  loading: false,
  error: undefined,
  verifyOTPResponse: undefined,
};

export const verifyOTPReducer = createReducer<VerifyOTPReducerType>(
  defaultState,
  {
    [ActionType.VERIFY_OTP](state: VerifyOTPReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.VERIFY_OTP_ERROR](
      state: VerifyOTPReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.VERIFY_OTP_SUCCESS](
      state: VerifyOTPReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        verifyOTPResponse: action.payload,
      };
    },

    [ActionType.VERIFY_OTP_RESET](state: VerifyOTPReducerType) {
      return {
        ...state,
        loading: false,
        error: null,
        verifyOTPResponse: undefined,
      };
    },
  }
);
